import React, {useEffect} from "react";
import {HashRouter as Router, Redirect, Route, Switch} from "react-router-dom";
import {Provider, useDispatch, useSelector} from "react-redux";

import {applyProduct} from "shared/networking/quotes";
import {createTicket} from "shared/networking/tickets";
import {closeRequestAssistanceModal} from "shared/reduxElements/slices/showRequestAssistance";
import RequestAssistanceModal from "shared/modals/RequestAssistanceModal";
import AssistanceSubmittedPage from "shared/pages/AssistanceSubmittedPage";

import {store} from "apps/QuoterApp/reduxElements/store";

import useNavigate from "apps/QuoterApp/hooks/useNavigate";
import {hideProductDetails, initQuote} from "apps/QuoterApp/reduxElements/slices/quoteRequest";
import {closeApplyModal} from "apps/QuoterApp/reduxElements/slices/showApplyModal";
import BasicInformationPage from "apps/QuoterApp/pages/BasicInformationPage";
import QuoteResultPage from "apps/QuoterApp/pages/QuoteResultPage";
import ProductDetailsModal from "apps/QuoterApp/modals/ProductDetailsModal";
import ApplyModal from "apps/QuoterApp/modals/ApplyModal";


function QuoterNavigatorModals() {
    const dispatch = useDispatch();
    const showRequestAssistance = useSelector(state => state.showRequestAssistance);
    const showProductDetails = useSelector(state => state.quoteRequest.showProductDetails);
    const showApplyModal = useSelector(state => state.showApplyModal);

    const {selectedProduct, result} = useSelector(state => state.quoteRequest);
    const {
        id: selectedProductId,
        premium: selectedPremium,
        term: selectedTerm,
    } = result.products.find(({id}) => id === selectedProduct) || {};
    const {id: quoteRequestId} = result;

    const {goToAssistanceSubmitted} = useNavigate();

    const urlParams = new URLSearchParams(window.location.search);
    const showClientView = urlParams.get('showClientView') !== '0';
    const allowTickets = urlParams.get('allowTickets') !== '0';

    return <>
        <RequestAssistanceModal
            show={showRequestAssistance}
            onClose={() => dispatch(closeRequestAssistanceModal())}
            goToAssistanceSubmitted={goToAssistanceSubmitted}
        />
        <ProductDetailsModal
            show={showProductDetails}
            onClose={() => dispatch(hideProductDetails())}
        />
        <ApplyModal
            show={showApplyModal}
            onClose={() => dispatch(closeApplyModal())}
            onApplyFull={async () => {
                try {
                    dispatch(closeApplyModal());
                    const {applicationUrl} = await applyProduct(
                        quoteRequestId,
                        selectedProductId,
                        selectedPremium,
                        selectedTerm,
                        showClientView,
                        allowTickets,
                    );
                    window.location.href = applicationUrl;
                } catch (e) {
                    // TODO: ALERT USER
                }
            }}
            onApplyQuick={async () => {
                try {
                    dispatch(closeApplyModal());
                    const {ticketUrl} = await createTicket(
                        quoteRequestId,
                        selectedProductId,
                        selectedPremium,
                        selectedTerm,
                        showClientView,
                    );
                    window.location.href = ticketUrl;
                } catch (e) {
                    // TODO: ALERT USER
                }
            }}
        />
    </>;
}


function QuoterNavigator() {
    const dispatch = useDispatch();

    const quoteInit = useSelector(state => state.quoteRequest.init);
    const urlParams = new URLSearchParams(window.location.search);
    const quoteToken = urlParams.get('quote');
    useEffect(() => {
        if (!quoteInit && quoteToken) {
            dispatch(initQuote(quoteToken));
        }
    }, [quoteInit, quoteToken]);

    return <Router basename={'/'}>
        <div>
            <Switch>
                <Route exact path="/">
                    <Redirect to="/input"/>
                </Route>
                <Route path="/input">
                    <BasicInformationPage/>
                </Route>
                <Route path="/result">
                    <QuoteResultPage/>
                </Route>
                <Route path="/assistanceSubmitted">
                    <AssistanceSubmittedPage/>
                </Route>
            </Switch>
        </div>

        <QuoterNavigatorModals/>
    </Router>;
}

function QuoterApp() {
    return <Provider store={store}>
        <QuoterNavigator/>
    </Provider>;
}

export default QuoterApp;
